import { RouteObject } from "react-router-dom";
import BenchmarkCockpitPage from "../pages/admin/benchmark/index";
import BenchmarkRunDetail from "../pages/admin/benchmark/details/BenchmarkRunDetail";
import BenchmarkCompare from "../pages/admin/benchmark/compare/BenchmarkCompare";

export const benchmarkRoutes: RouteObject[] = [
  {
    id: "benchmark-index",
    index: true,
    element: <BenchmarkCockpitPage />,
  },
  // Static segment is ranked above the dynamic ":id" by react-router, so it never collides.
  {
    id: "benchmark-compare",
    path: "compare",
    element: <BenchmarkCompare />,
  },
  {
    id: "benchmark-detail",
    path: ":id",
    element: <BenchmarkRunDetail />,
  },
];
